module.exports = __webpack_public_path__ + "media/images/proof_links/proof_green/reddit-b79404ed232f76120f6fece9e3884eb6.svg";